import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import { UserSession } from "../models/User/UserSession";

export const userApi = createApi({
  reducerPath: "user",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    getUserSession: build.query<UserSession, void>({
      query: () => "user-session",
    })
  })
});

export const {
  useGetUserSessionQuery
} = userApi;
